import * as TinyMCE from './TinyMCE'

export const docsProps = {
  TinyMCE,
}
